import "core-js/modules/es.array.push.js";
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
import { nextTick, onUnmounted, watch } from 'vue';
import * as echarts from 'echarts';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
export default {
  __name: 'AssetsEChart',
  props: {
    array: {
      type: Array,
      default: () => {}
    }
  },

  setup(__props) {
    const props = __props;
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const ind = Math.random(0, 1);
    watch(() => props.array, () => {
      nextTick(() => {
        if (props.array.length != 0) {
          initChart();
        }
      });
    }, {
      immediate: true
    });
    onUnmounted(() => {
      echarts.dispose(myChart);
    });
    var myChart = null;

    const initChart = () => {
      var xData = [];
      var dataList = [];

      if (props.array != '') {
        props.array.forEach(item => {
          xData.push(dayjs((item.createTime - 1) * 1000).tz("America/New_York").format("MM-DD"));
          dataList.push(item.amount);
        });
      } else {
        return;
      }

      var chartDom = document.getElementById('smallchart' + ind);
      myChart = echarts.init(chartDom);
      var option;
      var color = '#04AC92';
      option = {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xData,
          show: true,
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'gray',
              type: 'none'
            }
          }
        },
        yAxis: {
          type: 'value',
          show: true,
          splitNumber: 3,
          axisLine: {
            lineStyle: {
              color: 'gray',
              type: 'none'
            }
          } // type: 'log',
          // logBase: '10'

        },
        grid: {
          bottom: '10%',
          top: '10%',
          // top: '0%',
          left: '15%',
          right: '5%' // bottom: '0%'

        },
        series: [{
          data: dataList,
          type: 'line',
          symbol: 'none',
          color: color,
          smooth: true,
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: color
            }, {
              offset: 1,
              color: 'rgba(255, 255, 255,0)'
            }])
          }
        }]
      };
      option && myChart.setOption(option);
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: 'smallchart' + _unref(ind),
        style: {
          "height": "200px",
          "width": "100%"
        }
      }, null, 8, _hoisted_1);
    };
  }

};